import classNames from 'classnames';
import { Card } from '../Card';
import { Icon } from '../Icon';
import styles from './Alert.module.css';
import { AlertProps, IconMap } from './types';
function Alert({
  kind,
  global = false,
  size = 'medium',
  icon = false,
  iconKind: iconKind_,
  className,
  style,
  children
}: AlertProps) {
  const role = kind === 'error' ? 'alert' : 'status';
  const iconKind = iconKind_ ?? kind;
  const iconName = IconMap[iconKind];
  return <Card size={size} style={style} className={classNames(styles.alert, className, kind && styles[`kind-${kind}`], {
    [styles.global!]: global,
    [styles.small!]: size === 'small'
  })} role={role}>
      {icon && <div className={classNames(styles[`icon-${iconKind}`], styles.iconContainer)}>
          {/* The color from the container is inherited from the container parent. */}

          <Icon name={iconName} size={size === 'small' ? '200' : '300'} className={styles.icon} title={kind} />
        </div>}
      <div>{children}</div>
    </Card>;
}
export default Alert;